import {useMediaQuery} from './useMediaQuery'

export function useMediaQueries() {
    const minMobile = useMediaQuery("(min-width: 400px)")
    const minTablet = useMediaQuery("(min-width: 800px)")
    const minDesktop = useMediaQuery("(min-width: 1200px)")

    return { minMobile, minTablet, minDesktop }
}
